import React from 'react';
import { MdCheckCircle, MdError } from 'react-icons/md';

// Test e-postası sonuçları: [{ email, success, error? }]
export default function TestEmailResults({ results }) {
    if (!results || results.length === 0) return null;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 10 }}>
            {results.map(r => (
                <div key={r.email} style={{ display: 'flex', alignItems: 'flex-start', gap: 6, fontSize: 12 }}>
                    {r.success
                        ? <MdCheckCircle size={16} style={{ color: 'var(--success)', flexShrink: 0 }} />
                        : <MdError size={16} style={{ color: 'var(--danger)', flexShrink: 0 }} />}
                    <span style={{ wordBreak: 'break-all' }}>
                        <strong>{r.email}</strong>
                        {!r.success && r.error && <span style={{ color: 'var(--danger)' }}> — {r.error}</span>}
                    </span>
                </div>
            ))}
        </div>
    );
}
